export const FLAG_GB_STRIPE_PAYMENTS = "gb-stripe-payments";
export const FLAG_COOKIE_SETTINGS = "cookie-settings"


const f = {
    FLAG_GB_STRIPE_PAYMENTS,
    FLAG_COOKIE_SETTINGS,
};

export default f;